module.exports = __webpack_public_path__ + "img/back-groud-detail.31c1c744.svg";